import { useRef } from 'react';
import AppCookies from '@/lib/cookies';

const data = AppCookies.popRedirectData();

// Returns redirect data, but only in the first render (i.e. will be `undefined` on subsequent renders).
export function useRedirectData() {
  const ref = useRef(data);
  const { current } = ref;
  ref.current = undefined; // removed for subsequent renders
  return current;
}
